export const captionsTemplates = [
  {
    id: 'eb5de878-2997-41fe-858a-726e9e3712df',
    url: 'https://cdn.zapcap.ai/template-gifs/eb5de878-2997-41fe-858a-726e9e3712df.gif',
  },
  {
    id: 'a104df87-5b1a-4490-8cca-62e504a84615',
    url: 'https://cdn.zapcap.ai/template-gifs/a104df87-5b1a-4490-8cca-62e504a84615.gif',
  },
  {
    id: '07ffd4b8-4e1a-4ee3-8921-d58802953bcd',
    url: 'https://cdn.zapcap.ai/template-gifs/07ffd4b8-4e1a-4ee3-8921-d58802953bcd.gif',
  },
  {
    id: '14bcd077-3f98-465b-b788-1b628951c340',
    url: 'https://cdn.zapcap.ai/template-gifs/14bcd077-3f98-465b-b788-1b628951c340.gif',
  },
  {
    id: '1bb3b68b-6a93-453a-afd7-a774b62cdab8',
    url: 'https://cdn.zapcap.ai/template-gifs/1bb3b68b-6a93-453a-afd7-a774b62cdab8.gif',
  },
  {
    id: '21327a45-df89-46bc-8d56-34b8d29d3a0e',
    url: 'https://cdn.zapcap.ai/template-gifs/21327a45-df89-46bc-8d56-34b8d29d3a0e.gif',
  },
  {
    id: '46d20d67-255c-4c6a-b971-31fddcfea7f0',
    url: 'https://cdn.zapcap.ai/template-gifs/46d20d67-255c-4c6a-b971-31fddcfea7f0.gif',
  },
  {
    id: '50cdfac1-0a7a-48dd-af14-4d24971e213a',
    url: 'https://cdn.zapcap.ai/template-gifs/50cdfac1-0a7a-48dd-af14-4d24971e213a.gif',
  },
  {
    id: '55267be2-9eec-4d06-aff8-edcb401b112e',
    url: 'https://cdn.zapcap.ai/template-gifs/55267be2-9eec-4d06-aff8-edcb401b112e.gif',
  },
  {
    id: '5de632e7-0b02-4d15-8137-e004871e861b',
    url: 'https://cdn.zapcap.ai/template-gifs/5de632e7-0b02-4d15-8137-e004871e861b.gif',
  },
  {
    id: '7b946549-ae16-4085-9dd3-c20c82504daa',
    url: 'https://cdn.zapcap.ai/template-gifs/7b946549-ae16-4085-9dd3-c20c82504daa.gif',
  },
  {
    id: '982ad276-a76f-4d80-a4e2-b8fae0038464',
    url: 'https://cdn.zapcap.ai/template-gifs/982ad276-a76f-4d80-a4e2-b8fae0038464.gif',
  },
  {
    id: 'a51c5222-47a7-4c37-b052-7b9853d66bf6',
    url: 'https://cdn.zapcap.ai/template-gifs/a51c5222-47a7-4c37-b052-7b9853d66bf6.gif',
  },
  {
    id: 'a6760d82-72c1-4190-bfdb-7d9c908732f1',
    url: 'https://cdn.zapcap.ai/template-gifs/a6760d82-72c1-4190-bfdb-7d9c908732f1.gif',
  },
  {
    id: 'c88bff11-7f03-4066-94cd-88f71f9ecc68',
    url: 'https://cdn.zapcap.ai/template-gifs/c88bff11-7f03-4066-94cd-88f71f9ecc68.gif',
  },
  {
    id: 'ca050348-e2d0-49a7-9c75-7a5e8335c67d',
    url: 'https://cdn.zapcap.ai/template-gifs/ca050348-e2d0-49a7-9c75-7a5e8335c67d.gif',
  },
  {
    id: 'cfa6a20f-cacc-4fb6-b1d0-464a81fed6cf',
    url: 'https://cdn.zapcap.ai/template-gifs/cfa6a20f-cacc-4fb6-b1d0-464a81fed6cf.gif',
  },
  {
    id: 'd46bb0da-cce0-4507-909d-fa8904fb8ed7',
    url: 'https://cdn.zapcap.ai/template-gifs/d46bb0da-cce0-4507-909d-fa8904fb8ed7.gif',
  },
  {
    id: 'decf5309-2094-4257-a646-cabe1f1ba89a',
    url: 'https://cdn.zapcap.ai/template-gifs/decf5309-2094-4257-a646-cabe1f1ba89a.gif',
  },
  {
    id: 'dfe027d9-bd9d-4e55-a94f-d57ed368a060',
    url: 'https://cdn.zapcap.ai/template-gifs/dfe027d9-bd9d-4e55-a94f-d57ed368a060.gif',
  },
  {
    id: 'e7e758de-4eb4-460f-aeca-b2801ac7f8cc',
    url: 'https://cdn.zapcap.ai/template-gifs/e7e758de-4eb4-460f-aeca-b2801ac7f8cc.gif',
  },
];

export const defaultCaptionsTemplateId = captionsTemplates[0].id;

export const getTemplateShortList = (templateId?: string) => {
  const defaultTemplate = captionsTemplates.find((t) => t.id === defaultCaptionsTemplateId)!;

  if (templateId && templateId !== defaultCaptionsTemplateId) {
    const selectedTemplate = captionsTemplates.find((t) => t.id === templateId)!;
    const otherTemplates = captionsTemplates.filter((t) => t.id !== defaultCaptionsTemplateId && t.id !== templateId);
    const randomTemplate = otherTemplates[Math.floor(Math.random() * otherTemplates.length)];
    return [defaultTemplate, selectedTemplate, randomTemplate];
  }

  const otherTemplates = captionsTemplates.filter((t) => t.id !== defaultCaptionsTemplateId);
  const randomTemplates = otherTemplates.sort(() => Math.random() - 0.5).slice(0, 2);
  return [defaultTemplate, ...randomTemplates];
};

export type CaptionsTemplate = (typeof captionsTemplates)[number];
